export const namespace = 'userManagement';



export const Status = {
  STATUS_INITIAL: 'initial',
  STATUS_LOADING: 'loading',
  STATUS_LOADED: 'loaded',
  STATUS_ERROR: 'error',
  ACTIVE: 'active',
  DELETED: 'deleted'
};

export const ActionType = {
  LOAD_ORG_USERS: `${namespace}/LOAD_ORG_USERS`,
  SET_ORG_USERS: `${namespace}/SET_ORG_USERS`,
  LOAD_USER_ACTIVITIES: `${namespace}/LOAD_USER_ACTIVITIES`,
  SET_ACTIVITIES_STATUS: `${namespace}/SET_ACTIVITIES_STATUS`,
  SET_ORG_USERS_STATUS: `${namespace}/SET_ORG_USERS_STATUS`,
  LOAD_TEAMS: `${namespace}/LOAD_TEAMS`,
  SET_TEAMS: `${namespace}/SET_TEAMS`,
  SET_TEAMS_STATUS: `${namespace}/SET_TEAMS_STATUS`,
  UPDATE_TEAM: `${namespace}/UPDATE_TEAM`,
  CREATE_TEAM: `${namespace}/CREATE_TEAM`,
  DELETE_TEAM: `${namespace}/DELETE_TEAM`,
  UPDATE_USERS_TEAMS: `${namespace}/UPDATE_USERS_TEAMS`,
}

export const FetchResult = {
  FETCH_SUCCESS: 'SUCCESS'
};

export const setOrgUserStatus = (status) => ({
  payload: {
    status
  },
  type: ActionType.SET_ORG_USERS_STATUS
})

export const setUserActivitiesStatus = (status) => ({
  payload: {
    status
  },
  type: ActionType.SET_ACTIVITIES_STATUS
});

export const setTeamsStatus = (status) => ({
  payload: {
    status
  },
  type: ActionType.SET_TEAMS_STATUS
})


export const updateUsersTeams = (usersTeamsHashmap) => ({
  payload: {
    usersTeamsHashmap
  },
  type: ActionType.UPDATE_USERS_TEAMS
});

export const loadUserActivities = () => ({
  payload: {},
  type: ActionType.LOAD_USER_ACTIVITIES
});

export const loadOrgUsers = () => {
  return (dispatch) => {
    dispatch({
      payload: {},
      type: ActionType.LOAD_ORG_USERS
    })
  }
};

export const setOrgUser = (users) => ({
  payload: {
    users
  },
  type: ActionType.SET_ORG_USERS
});

export const loadTeams = (teamIds) => ({
  payload: {
    teamIds
  },
  type: ActionType.LOAD_TEAMS
});

export const setTeams = (teams) => ({
  payload: {
    teams
  },
  type: ActionType.SET_TEAMS
});

export const updateTeam = (teamInfo) => ({
  payload: {
    teamInfo
  },
  type: ActionType.UPDATE_TEAM
});

export const createTeam = (teamInfo) => ({
  payload: {
    teamInfo
  },
  type: ActionType.CREATE_TEAM
});

export const deleteTeam = (id) => ({
  payload: {
    id
  },
  type: ActionType.DELETE_TEAM
});
